module.exports = __webpack_public_path__ + "img/full-image-watermark-after.c93936f1.webp";